// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * LCC API
 * API for the LCC backend
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type Incident,
    IncidentFromJSON,
    IncidentToJSON,
} from '../models/Incident';
import {
    type IncidentHistoryResponse,
    IncidentHistoryResponseFromJSON,
    IncidentHistoryResponseToJSON,
} from '../models/IncidentHistoryResponse';
import {
    type IncidentQueryResponse,
    IncidentQueryResponseFromJSON,
    IncidentQueryResponseToJSON,
} from '../models/IncidentQueryResponse';
import {
    type IncidentSeverity,
    IncidentSeverityFromJSON,
    IncidentSeverityToJSON,
} from '../models/IncidentSeverity';
import {
    type IncidentStatus,
    IncidentStatusFromJSON,
    IncidentStatusToJSON,
} from '../models/IncidentStatus';

export interface GetIncidentRequest {
    /**
     * Incident ID
     */
    incidentId: string;
}

export interface GetIncidentHistoryRequest {
    /**
     * Incident ID
     */
    incidentId: string;
}

export interface GetIncidentsRequest {
    /**
     * Return only incidents that appeared in the specified room
     */
    room?: string;
    /**
     * Filter the result set to incidents, that are attached to the given context. This is a prefix filter and will also match context below the given string. A filter on `DeviceSet/S1-1016939` will also return incidents with context `DeviceSet/S1-1016939/FunctionalUnitSet/Fumehood/FunctionSet/Airflow`.
     * If Functional Units are linked into a device, the filter also return the incidents of the origin device.  
     * Example:   If following link is configured: `DeviceSet/S1-1016939/FunctionalUnitSet/SensorPanel -> DeviceSet/SP2DC800200/FunctionalUnitSet/SP2DC800200`   and the context parameter contains `DeviceSet/S1-1016939`, the result will also contain incidents from `DeviceSet/SP2DC800200/FunctionalUnitSet/SP2DC800200/FunctionSet/1` since the Function also appear in the context of the queried device.
     * 
     */
    context?: string;
    /**
     * filter incidents by severity
     */
    severity?: IncidentSeverity;
    /**
     * filter for active / inactive incidents
     */
    active?: boolean;
    /**
     * filter incident by current status
     */
    status?: IncidentStatus;
    /**
     * Operator lifecycle filter (strict-mode aware): "open" = not yet resolved/done, "resolved" = done. Independent of `status`.
     * 
     */
    lifecycle?: GetIncidentsLifecycleEnum;
    /**
     * Maximum number of items to return. Used together with `offset` for pagination.
     * 
     */
    limit?: number;
    /**
     * Number of items to skip before starting to return results. Defines the starting position of the returned slice when used together with `limit`.
     * 
     */
    offset?: number;
}

/**
 * 
 */
export class IncidentsApi extends runtime.BaseAPI {

    /**
     * Creates request options for getIncident without sending the request
     */
    async getIncidentRequestOpts(requestParameters: GetIncidentRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['incidentId'] == null) {
            throw new runtime.RequiredError(
                'incidentId',
                'Required parameter "incidentId" was null or undefined when calling getIncident().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", []);
        }


        let urlPath = `/incidents/{incidentId}`;
        urlPath = urlPath.replace('{incidentId}', encodeURIComponent(String(requestParameters['incidentId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Retrieve an incidents by id
     * Read incident
     */
    async getIncidentRaw(requestParameters: GetIncidentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Incident>> {
        const requestOptions = await this.getIncidentRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IncidentFromJSON(jsonValue));
    }

    /**
     * Retrieve an incidents by id
     * Read incident
     */
    async getIncident(requestParameters: GetIncidentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Incident> {
        const response = await this.getIncidentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getIncidentHistory without sending the request
     */
    async getIncidentHistoryRequestOpts(requestParameters: GetIncidentHistoryRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['incidentId'] == null) {
            throw new runtime.RequiredError(
                'incidentId',
                'Required parameter "incidentId" was null or undefined when calling getIncidentHistory().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", []);
        }


        let urlPath = `/incidents/{incidentId}/history`;
        urlPath = urlPath.replace('{incidentId}', encodeURIComponent(String(requestParameters['incidentId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Returns all Status changes of an incident and their origin. Items are ordered by time 
     * Read all status changes of an incident
     */
    async getIncidentHistoryRaw(requestParameters: GetIncidentHistoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IncidentHistoryResponse>> {
        const requestOptions = await this.getIncidentHistoryRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IncidentHistoryResponseFromJSON(jsonValue));
    }

    /**
     * Returns all Status changes of an incident and their origin. Items are ordered by time 
     * Read all status changes of an incident
     */
    async getIncidentHistory(requestParameters: GetIncidentHistoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IncidentHistoryResponse> {
        const response = await this.getIncidentHistoryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getIncidents without sending the request
     */
    async getIncidentsRequestOpts(requestParameters: GetIncidentsRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['room'] != null) {
            queryParameters['room'] = requestParameters['room'];
        }

        if (requestParameters['context'] != null) {
            queryParameters['context'] = requestParameters['context'];
        }

        if (requestParameters['severity'] != null) {
            queryParameters['severity'] = requestParameters['severity'];
        }

        if (requestParameters['active'] != null) {
            queryParameters['active'] = requestParameters['active'];
        }

        if (requestParameters['status'] != null) {
            queryParameters['status'] = requestParameters['status'];
        }

        if (requestParameters['lifecycle'] != null) {
            queryParameters['lifecycle'] = requestParameters['lifecycle'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", []);
        }


        let urlPath = `/incidents/`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Retrieve list of incidents, filtered by device and/or room
     * Read incidents
     */
    async getIncidentsRaw(requestParameters: GetIncidentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IncidentQueryResponse>> {
        const requestOptions = await this.getIncidentsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IncidentQueryResponseFromJSON(jsonValue));
    }

    /**
     * Retrieve list of incidents, filtered by device and/or room
     * Read incidents
     */
    async getIncidents(requestParameters: GetIncidentsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IncidentQueryResponse> {
        const response = await this.getIncidentsRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const GetIncidentsLifecycleEnum = {
    Open: 'open',
    Resolved: 'resolved'
} as const;
export type GetIncidentsLifecycleEnum = typeof GetIncidentsLifecycleEnum[keyof typeof GetIncidentsLifecycleEnum];
